import {FileType, ILoader, FileState, IFileState} from './rz-status_models'
import Constants from './rz-status_constants'

class Loader implements ILoader {    

    /**
    * A hashmap containing the states (changed/unchanged) for all JSON files
    **/
    fileStates : { [key:string]:IFileState} = {};

    constructor () {
        // This looks weird, but what it basically does, it creates a file state instance for every file type
        // & puts it into a map
       for (var n in FileType) {
            if (typeof(FileType[n]) === "number") {
                this.fileStates[FileType[n]] = new FileState((<any>FileType)[n]);
            }
       }
    }

    /**
    * Loads a JSON file and executes a callback on success, but only, if the file wasn'c changed
    * @param url the url to the file
    * @param callback The callback to be executed if a new file was loaded
    * @param fileTpe The file type (INCIDENTS, NEWS,...)
    **/
    loadFile(url: string, callback: (file: string, error: boolean) => void, fileType:FileType) {        
        var fileState:IFileState = this.fileStates[fileType];
        if (fileState.lastModified != null) {
            this.probeFile(url, callback, fileType);
        }
        else {
            this.getFile(url, callback, fileType);
        }
       
    }

    /**
    * Loads a file from a specified url & update the internal file modification states
    * @param url the url of the file
    * @param callback a callback to be executed as soon as the file was downloaded
    * @param the file type
    **/
    private getFile(url:string, callback:(file:string, error:boolean) => void, fileType:FileType) {
        var request = new XMLHttpRequest();
        request.onreadystatechange = () => {

            if (request.readyState == Constants.HttpReadyStates.Complete) {
                if(request.status == Constants.HttpStatusCodes.Ok) {
                    var lastModified:Date = this.getLastModifiedDate(request);                
                    this.fileStates[fileType].lastModified = lastModified;
                    callback(request.responseText, false);
                }
                else {
                    console.log('error, code != 200');
                    callback('', true);
                }
            }

        }
        request.open("GET", url, true);
        request.setRequestHeader('Accept', 'application/json');
        request.send();
    }


    /**
    * Probe modification date for a file (sending HTTP HEAD request, which reduce the HTTP overhead)
    * If the file was not midified, nothing is happening
    * If the file was changed, it will be downloaded and a callback will be executed
    * @param url the url to check
    * @param callback: A callback function to be executed if the file was downloaded completely
    **/
    private probeFile(url:string, callback:(file:string, error: boolean) => void, fileType:FileType) {
        var request = new XMLHttpRequest();
        request.onreadystatechange = () => {

            if (request.readyState == Constants.HttpReadyStates.Complete
                && request.status == Constants.HttpStatusCodes.Ok)
            {
               var lastModified:Date = this.getLastModifiedDate(request);
               if ((lastModified == null) || (this.fileStates[fileType].isChanged(lastModified))) {                   
                   // We need to load the new file                   
                   this.getFile(url,callback,fileType);
               }               
                        
            }
            // Something went wrong - we make sure the next time the file will be loaded
            else if (request.readyState == Constants.HttpReadyStates.Complete && request.status != Constants.HttpStatusCodes.Ok) {
                this.fileStates[fileType].lastModified = null;
            }
        }
        request.open("HEAD", url, true);
        request.setRequestHeader('Accept', 'application/json');
        request.send();
    }

    /**
    * Fetch the last modified header from a HTTP request & return it as da JavaScript date object
    * @param the HTTP request
    **/
    private getLastModifiedDate (request:XMLHttpRequest):Date {
        var date:Date=null;
        var lastModified:string = request.getResponseHeader("Last-Modified");
        if ((lastModified != null) && (lastModified != "")) {
            date = new Date(lastModified);
        }
        return(date);
    }

}

export default Loader;